import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { AnalyticsEventType, QuickQuoteFeatureFacade } from '@amfam/policy/replace-vehicle/feature';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { DockingBarService } from '@amfam/ui-kit';

@Component({
  selector: 'year-vin',
  templateUrl: './year-vin.component.html',
  styleUrls: ['./year-vin.component.scss'],
  standalone: false
})
export class YearVinComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() vinYearForm: UntypedFormGroup;
  @Input() errorMessage: string;
  @Input() years: number[];
  @Input() sameVINErrorMessage: string;
  @Input() isSameVin: boolean;
  @Input() yearLabel?: boolean;

  @Output() checkVinEvent = new EventEmitter<string>();

  // Form elements
  yearCtrl: AbstractControl;
  vinCtrl: AbstractControl;
  odometerCtrl: AbstractControl;

  constructor(
    public copyService: CopyService,
    public quickQuoteFeatureFacade: QuickQuoteFeatureFacade,
    private formBuilder: UntypedFormBuilder,
    private dockingBarService: DockingBarService
  ) {}

  ngOnInit() {
    this.dockingBarService.registerHeading('Replace Vehicle');
    this.yearCtrl = this.vinYearForm.controls['year'];
    this.vinCtrl = this.vinYearForm.controls['vin'];
  }

  ngAfterViewInit() {
    this.quickQuoteFeatureFacade.sendAnalytics(AnalyticsEventType.REPLACE_VEHICLE_VIN_YEAR);
  }

  verifyVin() {
    this.checkVinEvent.emit(this.vinYearForm.controls['vin'].value);
  }

  ngOnDestroy(): void {
    this.vinYearForm.patchValue({
      vin: '',
      year: ''
    });
    this.isSameVin = false;
    this.vinYearForm.controls['vin'].clearValidators();
    this.vinYearForm.controls['year'].clearValidators();
  }
}
